const base = `//www.dreamchimney.com/api`;
export const urlTracks = base + "/tracks";

export const urlTopGenres = urlTracks + "/top/genres";
export const urlTopArtists = urlTracks + "/top/artists";
export const urlTopChimneys = urlTracks + "/top/chimneys";

export const getTopGenres = axios => axios.get(urlTopGenres);
export const getTopArtists = axios => axios.get(urlTopArtists);
export const getTopChimneys = axios => axios.get(urlTopChimneys);
